import { Text, View } from '@react-pdf/renderer'
import dayjs from 'dayjs'

import { NoData } from '@/components/StatsExport/components/NoData/NoData'
import { styles } from '@/components/StatsExport/components/UserSection/UsersSection.config'
import type { UsersSectionProps } from '@/components/StatsExport/components/UserSection/UsersSection.types'

export function UsersSection({ data, title }: UsersSectionProps) {
  if (!data) return <NoData title={title} />

  const date = dayjs(data.startDate)
  const month = date.format('MMM')
  const year = date.year()

  return (
    <View style={styles.box} wrap={false}>
      <View style={styles.contentContainer}>
        <Text style={styles.title}>Users</Text>

        <View style={styles.bottomText}>
          <Text style={styles.text}>{data.value}</Text>

          <Text style={styles.date}>{`As of, ${month} ${year}`}</Text>
        </View>
      </View>
    </View>
  )
}
